function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _regeneratorKeys(e) {
  var n = Object(e),
    r = [];
  for (var t in n) r.unshift(t);
  return function e() {
    for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
    return e.done = !0, e;
  };
}
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var PeerService = require('saito-js/lib/peer_service')["default"];
var Transaction = require('../../lib/saito/transaction')["default"];
var saito = require('./../../lib/saito/saito');
var ModTemplate = require('../../lib/templates/modtemplate');
var ArcadeMain = require('./lib/ui/main');
var SaitoHeader = require('./../../lib/saito/ui/saito-header/saito-header');
var InviteManager = require('./lib/ui/invites');
var GameWizard = require('./lib/ui/overlays/wizard');
var GameInvitationLink = require('./../../lib/saito/ui/modals/saito-link/saito-link');
var Invite = require('./lib/ui/invite');
var LoungeOverlay = require('./lib/ui/overlays/lounge');
var SaitoOverlay = require('../../lib/saito/ui/saito-overlay/saito-overlay');
var arcadeHome = require('./index');
var Arcade = /*#__PURE__*/function (_ModTemplate) {
  function Arcade(app) {
    var _this;
    _classCallCheck(this, Arcade);
    _this = _callSuper(this, Arcade, [app]);

    //
    // module basics
    //
    _this.name = 'Arcade';
    _this.slug = 'arcade';
    _this.sudo = false;
    _this.description = 'Interface for creating and joining games coded for the Saito Open Source Game Engine.';
    _this.categories = 'Games Entertainment Appspace';
    _this.icon = 'fas fa-gamepad';
    _this.styles = ['/arcade/style.css'];
    _this.affix_callbacks_to = [];

    //
    // modules and games
    //
    _this.mods = [];
    _this.games = {};

    ////////////////////////////////////////////////////
    ///////////////////  UI STATE  /////////////////////
    ////////////////////////////////////////////////////

    //
    // UI Components
    //
    _this.ui = null;
    _this.header = null;
    _this.lounge_overlay = null;
    _this.wizard_overlay = null;
    _this.share_overlay = null;

    //
    // Still using deprecated peerhandshakecomplete rather than peerservice
    //
    _this.services = [_this.app.network.createPeerService(null, 'arcade', '', 'saito')];
    _this.possibleHome = 1;
    _this.social = {
      twitter: '@SaitoOfficial',
      title: '🟥 Saito Arcade',
      url: 'https://saito.io/arcade/',
      description: 'Peer to peer gaming on the blockchain',
      image: 'https://saito.tech/wp-content/uploads/2023/11/arcade-300x300.png'
    };
    app.connection.on('arcade-issue-challenge', /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref) {
        var game, players, options, tx;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              game = _ref.game, players = _ref.players, options = _ref.options;
              if (!_this.challenge_tx) {
                _context.n = 2;
                break;
              }
              _context.n = 1;
              return _this.createJoinTransaction(_this.challenge_tx);
            case 1:
              tx = _context.v;
              _context.n = 4;
              break;
            case 2:
              _context.n = 3;
              return _this.createChallengeTransaction(game, players, options);
            case 3:
              tx = _context.v;
            case 4:
              if (tx) {
                app.connection.emit('relay-send-message', {
                  recipient: players,
                  request: 'arcade spv update',
                  data: tx.toJson()
                });
              }
            case 5:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    app.connection.on('arcade-notify-player-turn', function (game_id, target, status) {
      var _iterator = _createForOfIteratorHelper(app.options.games),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var game = _step.value;
          if (game.id == game_id) {
            //let prev_target = game.target;

            game.status = status;
            game.target = target;

            // save with turn updated, so reload works
            app.storage.saveOptions();
            siteMessage("It is now your turn in ".concat(game.module), 5000);
            _this.renderInvites();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
    app.connection.on('arcade-gametable-addplayer', function (game_id) {
      console.info('EVENT: arcade-gametable-addplayer');
      var game_tx = _this.returnGameTransaction(game_id);
      if (game_tx) {
        _this.sendJoinTransaction({
          tx: game_tx,
          game_name: 'open_table'
        });
      }
    });
    app.connection.on('arcade-gametable-removeplayer', function (game_id, player_stats) {
      console.info('EVENT: arcade-gametable-removeplayer');
      var game_tx = _this.returnGameTransaction(game_id);
      if (game_tx) {
        _this.sendLeaveTransaction(game_tx, player_stats);
      }
    });
    app.connection.on('arcade-game-ready-render-request', function (game_details) {
      if (!(game_details !== null && game_details !== void 0 && game_details.id)) return;
      if (_this.browser_active) {
        _this.render('lounge_overlay', {
          game_id: game_details.id
        });
        if (_this.app.BROWSER && _this.ui) {
          var game_mod = _this.app.modules.returnModuleBySlug(game_details === null || game_details === void 0 ? void 0 : game_details.slug);
          if (game_mod && !(game_mod.maxPlayers === 1 || _this.app.browser.isMobileBrowser())) {
            _this.app.browser.createTabNotification('Game ready!', (game_details === null || game_details === void 0 ? void 0 : game_details.name) || '');
            siteMessage("".concat((game_details === null || game_details === void 0 ? void 0 : game_details.name) || 'Game', " ready to play!"));
            try {
              var chime = new Audio('/saito/sound/Jinja.mp3');
              chime.play();
            } catch (e) {}
          }
        }
      } else {
        _this._showReadyPopup(game_details);
      }
    });
    app.connection.on('arcade-continue-game-from-options', /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(game_mod) {
        var _game_mod$game;
        var id, game, game_tx, _newInvite, newInvite;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              id = (_game_mod$game = game_mod.game) === null || _game_mod$game === void 0 ? void 0 : _game_mod$game.id;
              if (id) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              console.info('arcade-continue-game-from-options');
              game = _this.returnGame(id);
              if (game) {
                _context2.n = 3;
                break;
              }
              console.info('ARCADE: Creating fresh transaction');
              _context2.n = 2;
              return _this.createPseudoTransaction(game_mod.game);
            case 2:
              game_tx = _context2.v;
              _this.addGame(game_tx, 'closed');
              _newInvite = new Invite(app, _this, null, 'short', game_tx, _this.publicKey);
              _this.render('lounge_overlay', {
                invite_data: _newInvite.invite_data
              });
              return _context2.a(2);
            case 3:
              delete game.tx.msg.time_finished;
              delete game.tx.msg.method;
              delete game.tx.msg.winner;
              game.tx.msg.request = 'paused';
              console.info('ARCADE: ', JSON.parse(JSON.stringify(game.tx)), JSON.parse(JSON.stringify(game_mod.game)));
              newInvite = new Invite(app, _this, null, 'short', game.tx, _this.publicKey);
              _this.render('lounge_overlay', {
                invite_data: newInvite.invite_data
              });
            case 4:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }());
    return _this;
  }

  //////////////////////////////
  // INITIALIZATION FUNCTIONS //
  //////////////////////////////
  //
  // runs when the module initializes, note that at this point the network
  // may not be up. use onPeerHandshakeCompete() to make requests over the
  // network and process the results.
  //
  _inherits(Arcade, _ModTemplate);
  return _createClass(Arcade, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(app) {
        var _this2 = this;
        var _window, _iterator2, _step2, game, game_tx, _game_tx, _t;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.n = 1;
              return _superPropGet(Arcade, "initialize", this, 3)([app]);
            case 1:
              //
              // compile list of arcade games
              //
              app.modules.returnModulesRespondingTo('arcade-games').forEach(function (game_mod) {
                _this2.mods.push(game_mod);
                //
                // and listen to their transactions
                //
                _this2.affix_callbacks_to.push(game_mod.name);
              });
              if (!app.options.arcade) {
                app.options.arcade = {};
              }

              //
              // Maybe good, maybe not... Only sorts on fresh load...
              //
              this.mods = this.mods.sort(function (a, b) {
                var _app$options$arcade;
                //Default sorting 1, 0, -1
                var b_count = b.sort_priority;
                var a_count = a.sort_priority;
                if (((_app$options$arcade = app.options.arcade) === null || _app$options$arcade === void 0 ? void 0 : _app$options$arcade.last_game) == b.name) {
                  return 1;
                }

                //Add user behavior metrics
                if (app.options.arcade[b.name]) {
                  b_count += 2 * app.options.arcade[b.name];
                }
                if (app.options.arcade[a.name]) {
                  a_count += 2 * app.options.arcade[a.name];
                }
                return b_count - a_count;
              });

              //
              // If we have a browser (are a user)
              // initialize some UI components and query the list of games to display
              //
              if (!(this.app.BROWSER == 1)) {
                _context3.n = 12;
                break;
              }
              if (this.browser_active && this.app.browser.returnURLParameter('moderator')) {
                this.sudo = true;
              }
              this.lounge_overlay = new LoungeOverlay(this.app, this, null);
              this.wizard_overlay = new GameWizard(this.app, this, null, {});
              this.renderIntos = this.renderIntos || {};

              //
              // my games stored in local wallet
              //
              if (!this.app.options.games) {
                _context3.n = 11;
                break;
              }
              this.purge();
              _iterator2 = _createForOfIteratorHelper(this.app.options.games);
              _context3.p = 2;
              _iterator2.s();
            case 3:
              if ((_step2 = _iterator2.n()).done) {
                _context3.n = 8;
                break;
              }
              game = _step2.value;
              if (game.players.includes(this.publicKey) || game.accepted.includes(this.publicKey)) {
                _context3.n = 4;
                break;
              }
              return _context3.a(3, 7);
            case 4:
              if (!game.over) {
                _context3.n = 5;
                break;
              }
              return _context3.a(3, 7);
            case 5:
              _context3.n = 6;
              return this.createPseudoTransaction(game);
            case 6:
              game_tx = _context3.v;
              this.addGame(game_tx, 'active');

              //
              // and add to list of my games
              //
              if (!game.over) {
                this.addGame(game_tx, 'active');
              } else {
                this.addGame(game_tx, 'over');
              }
            case 7:
              _context3.n = 3;
              break;
            case 8:
              _context3.n = 10;
              break;
            case 9:
              _context3.p = 9;
              _t = _context3.v;
              _iterator2.e(_t);
            case 10:
              _context3.p = 10;
              _iterator2.f();
              return _context3.f(10);
            case 11:
              //Check for server delivered data load
              if ((_window = window) !== null && _window !== void 0 && _window.game) {
                _game_tx = new Transaction();
                _game_tx.deserialize_from_web(app, window.game);
                this.addGame(_game_tx);
              }
              this.renderInvites();
              setInterval(function () {
                _this2.purge();
                _this2.renderInvites();
              }, 90000);
            case 12:
              try {
                this.leagueCallback = this.app.modules.returnFirstRespondTo('league-membership');
              } catch (err) {
                this.leagueCallback = {};
              }
            case 13:
              return _context3.a(2);
          }
        }, _callee3, this, [[2, 9, 10, 11]]);
      }));
      function initialize(_x3) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "renderInvites",
    value: function renderInvites() {
      if (!this.app.BROWSER) {
        return;
      }
      if (this.browser_active) {
        if (this.ui) {
          this.ui.renderInvites();
        }
      } else {
        if (this.invite_manager) {
          this.invite_manager.render();
        }
      }
    }
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var mode,
          data,
          _iterator3,
          _step3,
          mod,
          cm,
          _args4 = arguments;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              mode = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : null;
              data = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};
              if (this.app.BROWSER) {
                _context4.n = 1;
                break;
              }
              console.warn('Node attempting to render Arcade...');
              return _context4.a(2);
            case 1:
              if (this.header) {
                _context4.n = 3;
                break;
              }
              this.header = new SaitoHeader(this.app, this);
              _context4.n = 2;
              return this.header.initialize(this.app);
            case 2:
              this.header.header_class = 'arcade';
              this.addComponent(this.header);
            case 3:
              if (!this.ui) {
                this.ui = new ArcadeMain(this.app, this);
                this.addComponent(this.ui);
              }

              //
              // add chat manager
              //
              if (!this.chat_components_added) {
                _iterator3 = _createForOfIteratorHelper(this.app.modules.returnModulesRespondingTo('chat-manager'));
                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    mod = _step3.value;
                    cm = mod.respondTo('chat-manager');
                    cm.container = '.arcade-sidebar';
                    cm.render_manager_to_screen = 1;
                    this.addComponent(cm);
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }
                this.chat_components_added = true;
              }

              //
              // Only render the arcade if the arcade is active!!!
              //
              if (!this.browser_active) {
                _context4.n = 4;
                break;
              }
              _context4.n = 4;
              return _superPropGet(Arcade, "render", this, 3)([]);
            case 4:
              if (!(mode === 'lounge_overlay')) {
                _context4.n = 5;
                break;
              }
              if (this.lounge_overlay && (data.invite_data != null || data.game_id != null)) {
                this.lounge_overlay.invite = data.invite_data != null ? data.invite_data : null;
                this.lounge_overlay.game_id = data.game_id != null ? data.game_id : null;
                this.lounge_overlay.observer_has_archive_data = data.observer_has_archive_data === true;
                this.lounge_overlay.observer_game_module_slug = data.game_module_slug != null ? data.game_module_slug : null;
                this.lounge_overlay.render();
              }
              return _context4.a(2);
            case 5:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }() //
    // let other modules know if we can render into any components
    //
  }, {
    key: "canRenderInto",
    value: function canRenderInto(qs) {
      if (qs === '.redsquare-sidebar') {
        return true;
      }
      if (qs === '.arcade-sidebar') {
        return true;
      }
      return false;
    }

    //
    // render components into other modules on-request
    //
  }, {
    key: "renderInto",
    value: function () {
      var _renderInto = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(qs) {
        var _iterator4, _step4, comp, _t2;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              if (!(qs == '.arcade-sidebar')) {
                _context5.n = 2;
                break;
              }
              if (this.ui) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2);
            case 1:
              if (!this.renderIntos[qs]) {
                this.styles = ['/arcade/style.css'];
                this.renderIntos[qs] = [];
                this.renderIntos[qs].push(this.ui.sidebar);
                this.attachStyleSheets();
              }
            case 2:
              if (qs == '.redsquare-sidebar') {
                if (!this.renderIntos[qs]) {
                  this.styles = ['/arcade/style.css'];
                  this.renderIntos[qs] = [];
                  this.invite_manager = new InviteManager(this.app, this, qs);
                  this.invite_manager.type = 'short';
                  this.renderIntos[qs].push(this.invite_manager);
                  this.attachStyleSheets();
                }
              }
              if (!(this.renderIntos[qs] != null && this.renderIntos[qs].length > 0)) {
                _context5.n = 9;
                break;
              }
              _iterator4 = _createForOfIteratorHelper(this.renderIntos[qs]);
              _context5.p = 3;
              _iterator4.s();
            case 4:
              if ((_step4 = _iterator4.n()).done) {
                _context5.n = 6;
                break;
              }
              comp = _step4.value;
              _context5.n = 5;
              return comp.render();
            case 5:
              _context5.n = 4;
              break;
            case 6:
              _context5.n = 8;
              break;
            case 7:
              _context5.p = 7;
              _t2 = _context5.v;
              _iterator4.e(_t2);
            case 8:
              _context5.p = 8;
              _iterator4.f();
              return _context5.f(8);
            case 9:
              return _context5.a(2);
          }
        }, _callee5, this, [[3, 7, 8, 9]]);
      }));
      function renderInto(_x4) {
        return _renderInto.apply(this, arguments);
      }
      return renderInto;
    }() //
    // flexible inter-module-communications
    //
  }, {
    key: "respondTo",
    value: function respondTo() {
      var _this3 = this;
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var obj = arguments.length > 1 ? arguments[1] : undefined;
      // Phase 1: no direct UI instantiation, no .render() calls; return references only

      if (type === 'saito-header') {
        var x = [];
        if (!this.browser_active) {
          this.attachStyleSheets();
          x.push({
            text: 'Arcade',
            icon: this.icon || 'fas fa-gamepad',
            rank: 10,
            type: 'quicklaunch',
            callback: function callback(app, id) {
              navigateWindow("/arcade");
            },
            navigation: '/arcade'
          });
        }
        return x;
      }
      if (type === 'saito-link') {
        var urlParams = new URL(obj === null || obj === void 0 ? void 0 : obj.link).searchParams;
        if (urlParams.has('game_id') && urlParams.has('game')) {
          return {
            processLink: function () {
              var _processLink = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(link) {
                var _yield$_this3$returnG, game_tx, from_archive, game_module_slug, invite, game_id;
                return _regenerator().w(function (_context6) {
                  while (1) switch (_context6.n) {
                    case 0:
                      _context6.n = 1;
                      return _this3.returnGameInvite(urlParams.get('game_id'), urlParams.get('game'));
                    case 1:
                      _yield$_this3$returnG = _context6.v;
                      game_tx = _yield$_this3$returnG.game_tx;
                      from_archive = _yield$_this3$returnG.from_archive;
                      game_module_slug = urlParams.get('game');
                      if (game_tx && !from_archive && game_tx.msg.request !== 'cancel' && game_tx.msg.request !== 'closed') {
                        _this3.addGame(game_tx);
                        if (_this3.isAvailableGame(game_tx)) {
                          game_tx.msg.options.desired_opponent_publickey = _this3.publicKey;
                          _this3.removeGame(game_tx.signature);
                          _this3.addGame(game_tx);
                        }
                        invite = new Invite(_this3.app, _this3, null, null, game_tx, _this3.publicKey);
                        _this3.render('lounge_overlay', {
                          invite_data: invite.invite_data
                        });
                      } else {
                        game_id = urlParams.get('game_id');
                        try {
                          game_id = decodeURIComponent(game_id);
                        } catch (_) {}
                        _this3.render('lounge_overlay', {
                          game_id: game_id,
                          observer_has_archive_data: !!game_tx,
                          game_module_slug: game_module_slug || null
                        });
                      }
                    case 2:
                      return _context6.a(2);
                  }
                }, _callee6);
              }));
              function processLink(_x5) {
                return _processLink.apply(this, arguments);
              }
              return processLink;
            }()
          };
        }
      }
      if (type === 'saito-filter-link') {
        if (obj.slug == this.returnSlug()) {
          if (!obj.url.includes('invite')) {
            return {
              info: [],
              no_photo: true
            };
          } else {
            return {
              info: ['title']
            };
          }
        }
      }
      return _superPropGet(Arcade, "respondTo", this, 3)([type, obj]);
    }
  }, {
    key: "createPseudoTransaction",
    value: function () {
      var _createPseudoTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(game) {
        var _game$step;
        var game_tx, msg;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee();
            case 1:
              game_tx = _context7.v;
              if (game.accepted) {
                game.accepted.forEach(function (player) {
                  game_tx.addTo(player);
                  game_tx.addFrom(player);
                });
              } else {
                game_tx.addFrom(this.publicKey);
                game_tx.addTo(this.publicKey);
              }
              msg = {
                //ts
                module: 'Arcade',
                request: 'loaded',
                //will be overwritten as "active" when added
                game: game.module,
                options: game.options,
                players_needed: game.players_needed,
                players: game.accepted,
                players_sigs: [],
                //Only used to verify cryptology when initializing the game
                originator: game.originator,
                //winner: game.winner,
                step: game === null || game === void 0 || (_game$step = game.step) === null || _game$step === void 0 ? void 0 : _game$step.game,
                timestamp: game === null || game === void 0 ? void 0 : game.timestamp
              };
              game_tx.signature = game.id;
              game_tx.msg = msg;
              return _context7.a(2, game_tx);
          }
        }, _callee7, this);
      }));
      function createPseudoTransaction(_x6) {
        return _createPseudoTransaction.apply(this, arguments);
      }
      return createPseudoTransaction;
    }() //////////////////////////////////////////////////////////////////////
    // This function is called *once* when a peer connection is established,
    // as opposed to onPeerServiceUp, which is called once per service...
    // Though mostly, deprecated, this is still the function that gets called based
    // on the wasm-triggered event 'handshake_complete'
    //////////////////////////////////////////////////////////////////////
  }, {
    key: "onPeerHandshakeComplete",
    value: function () {
      var _onPeerHandshakeComplete = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(app, peer) {
        var newtx, id, record;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              if (app.BROWSER) {
                _context8.n = 3;
                break;
              }
              _context8.n = 1;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee();
            case 1:
              newtx = _context8.v;
              newtx.msg = {
                module: 'Arcade',
                request: 'arcade update peer status',
                data: {
                  publickey: peer.publicKey,
                  status: 'online'
                }
              };
              _context8.n = 2;
              return newtx.sign();
            case 2:
              this.notifyPeers(newtx);
              for (id in this.games) {
                record = this.games[id];
                if (record.tx.from[0].publicKey == peer.publicKey) {
                  record.is_sender_reachable = true;
                }
              }
              return _context8.a(2);
            case 3:
              return _context8.a(2);
          }
        }, _callee8, this);
      }));
      function onPeerHandshakeComplete(_x7, _x8) {
        return _onPeerHandshakeComplete.apply(this, arguments);
      }
      return onPeerHandshakeComplete;
    }()
  }, {
    key: "onPeerServiceUp",
    value: function () {
      var _onPeerServiceUp = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(app, peer) {
        var _this4 = this;
        var service,
          arcade_self,
          _args1 = arguments;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              service = _args1.length > 2 && _args1[2] !== undefined ? _args1[2] : {};
              arcade_self = this;
              if (service.service == 'arcade') {
                this.app.network.sendRequestAsTransaction('arcade invite list', {}, /*#__PURE__*/function () {
                  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(txs) {
                    var _iterator5, _step5, _loop, game_id, game_module_slug, _yield$arcade_self$re, game_tx, from_archive, invite, _t3;
                    return _regenerator().w(function (_context0) {
                      while (1) switch (_context0.p = _context0.n) {
                        case 0:
                          if (!((txs === null || txs === void 0 ? void 0 : txs.length) > 0)) {
                            _context0.n = 8;
                            break;
                          }
                          _iterator5 = _createForOfIteratorHelper(txs);
                          _context0.p = 1;
                          _loop = /*#__PURE__*/_regenerator().m(function _loop() {
                            var _game_tx$msg;
                            var serial_tx, game_tx, status, _arcade_self$app$opti, exists_locally, msg, game_added;
                            return _regenerator().w(function (_context9) {
                              while (1) switch (_context9.n) {
                                case 0:
                                  serial_tx = _step5.value;
                                  game_tx = new Transaction();
                                  game_tx.deserialize_from_web(app, serial_tx);
                                  status = game_tx === null || game_tx === void 0 || (_game_tx$msg = game_tx.msg) === null || _game_tx$msg === void 0 ? void 0 : _game_tx$msg.request;
                                  if (!arcade_self.isMyGame(game_tx)) {
                                    _context9.n = 1;
                                    break;
                                  }
                                  exists_locally = (_arcade_self$app$opti = arcade_self.app.options) === null || _arcade_self$app$opti === void 0 || (_arcade_self$app$opti = _arcade_self$app$opti.games) === null || _arcade_self$app$opti === void 0 ? void 0 : _arcade_self$app$opti.find(function (g) {
                                    return g.id === game_tx.signature;
                                  });
                                  if (exists_locally) {
                                    _context9.n = 1;
                                    break;
                                  }
                                  //
                                  // if this invite was created in the last 30 seconds, show it anyway
                                  // as I may just not have received it online and refreshed...
                                  //
                                  msg = game_tx.returnMessage();
                                  if (!(Date.now() - msg.timestamp > 30000)) {
                                    _context9.n = 1;
                                    break;
                                  }
                                  return _context9.a(2, 1);
                                case 1:
                                  game_added = arcade_self.addGame(game_tx); //Game is marked as "active" but we didn't already add it from our app.options file...
                                  if (status == 'active' && game_added && arcade_self.isMyGame(game_tx)) {
                                    game_tx.msg.game_id = game_tx.signature;
                                    arcade_self.receiveAcceptTransaction(game_tx);
                                  }
                                case 2:
                                  return _context9.a(2);
                              }
                            }, _loop);
                          });
                          _iterator5.s();
                        case 2:
                          if ((_step5 = _iterator5.n()).done) {
                            _context0.n = 5;
                            break;
                          }
                          return _context0.d(_regeneratorValues(_loop()), 3);
                        case 3:
                          if (!_context0.v) {
                            _context0.n = 4;
                            break;
                          }
                          return _context0.a(3, 4);
                        case 4:
                          _context0.n = 2;
                          break;
                        case 5:
                          _context0.n = 7;
                          break;
                        case 6:
                          _context0.p = 6;
                          _t3 = _context0.v;
                          _iterator5.e(_t3);
                        case 7:
                          _context0.p = 7;
                          _iterator5.f();
                          return _context0.f(7);
                        case 8:
                          if (!arcade_self.app.browser.returnURLParameter('game_id')) {
                            _context0.n = 10;
                            break;
                          }
                          game_id = arcade_self.app.browser.returnURLParameter('game_id');
                          try {
                            game_id = decodeURIComponent(game_id);
                          } catch (_) {}
                          game_module_slug = arcade_self.app.browser.returnURLParameter('game');
                          _context0.n = 9;
                          return arcade_self.returnGameInvite(game_id, game_module_slug);
                        case 9:
                          _yield$arcade_self$re = _context0.v;
                          game_tx = _yield$arcade_self$re.game_tx;
                          from_archive = _yield$arcade_self$re.from_archive;
                          if (game_tx && !from_archive && game_tx.msg.request !== 'cancel' && game_tx.msg.request !== 'closed') {
                            arcade_self.addGame(game_tx);
                            if (arcade_self.isAvailableGame(game_tx)) {
                              game_tx.msg.options.desired_opponent_publickey = arcade_self.publicKey;
                              arcade_self.removeGame(game_tx.signature);
                              arcade_self.addGame(game_tx);
                            }
                            invite = new Invite(arcade_self.app, arcade_self, null, null, game_tx, arcade_self.publicKey);
                            arcade_self.render('lounge_overlay', {
                              invite_data: invite.invite_data
                            });
                          } else {
                            arcade_self.render('lounge_overlay', {
                              game_id: game_id,
                              observer_has_archive_data: !!game_tx,
                              game_module_slug: game_module_slug || null
                            });
                          }
                          window.history.replaceState('', '', "/arcade/");
                        case 10:
                          _this4.renderInvites();
                          app.connection.emit('arcade-data-loaded');
                        case 11:
                          return _context0.a(2);
                      }
                    }, _callee9, null, [[1, 6, 7, 8]]);
                  }));
                  return function (_x1) {
                    return _ref4.apply(this, arguments);
                  };
                }());
              }

              //
              // I am going to comment this out for a bit, because I don't know if we still need it
              // It was "broken" and so not working for... a while
              // The idea is to query the last 10 moves of all your saved games in case you didn't get them
              // on/off chain and then rerun them
              // I think it might be essential for asynchronous gaming since we don't know that we will
              // get lite blocks going back too far
              //
              if (service.service === 'archive') {
                /*for (let game of this.app.options.games) {
                	if (game?.over) {
                		continue;
                	}
                		let game_mod = this.app.modules.returnModule(game.module);
                		if (!game_mod) {
                		continue;
                	}
                		this.app.storage.loadTransactions(
                		{
                			field1: game.module,
                			field4: game.id
                		},
                		async (txs) => {
                			if (txs?.length > 0) {
                				for (let i = txs.length - 1; i >= 0; i--) {
                					// arcade
                					await this.onConfirmation(-1, txs[i], 0);
                						// game mod
                					await game_mod.onConfirmation(-1, txs[i], 0);
                				}
                			}
                		},
                		peer
                	);
                }*/
              }
            case 1:
              return _context1.a(2);
          }
        }, _callee0, this);
      }));
      function onPeerServiceUp(_x9, _x0) {
        return _onPeerServiceUp.apply(this, arguments);
      }
      return onPeerServiceUp;
    }()
  }, {
    key: "returnGameInvite",
    value: function () {
      var _returnGameInvite = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(game_id, game_module) {
        var _this$games$game_id$t,
          _this$games$game_id,
          _this$app$options,
          _this5 = this;
        var game_tx, from_archive, opt;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              try {
                game_id = decodeURIComponent(game_id);
              } catch (_) {}
              game_tx = (_this$games$game_id$t = (_this$games$game_id = this.games[game_id]) === null || _this$games$game_id === void 0 ? void 0 : _this$games$game_id.tx) !== null && _this$games$game_id$t !== void 0 ? _this$games$game_id$t : null;
              from_archive = false;
              if (!(!game_tx && (_this$app$options = this.app.options) !== null && _this$app$options !== void 0 && (_this$app$options = _this$app$options.games) !== null && _this$app$options !== void 0 && _this$app$options.length)) {
                _context10.n = 2;
                break;
              }
              opt = this.app.options.games.find(function (g) {
                return g.id === game_id;
              });
              if (!opt) {
                _context10.n = 2;
                break;
              }
              _context10.n = 1;
              return this.createPseudoTransaction(opt);
            case 1:
              game_tx = _context10.v;
            case 2:
              if (!(!game_tx && game_module)) {
                _context10.n = 4;
                break;
              }
              _context10.n = 3;
              return new Promise(function (resolve) {
                _this5.app.storage.loadTransactions({
                  field1: game_module,
                  field4: game_id,
                  order_by: 'field5',
                  order: 'ASC',
                  limit: 1
                }, function (txs) {
                  var tx = txs && txs.length ? txs[0] : null;
                  resolve(tx || null);
                });
              });
            case 3:
              game_tx = _context10.v;
              if (game_tx) {
                from_archive = true;
              }
            case 4:
              return _context10.a(2, {
                game_tx: game_tx,
                from_archive: from_archive
              });
          }
        }, _callee1, this);
      }));
      function returnGameInvite(_x10, _x11) {
        return _returnGameInvite.apply(this, arguments);
      }
      return returnGameInvite;
    }() ////////////////////////////////////////////////////
    // NETWORK FUNCTIONS -- sending and receiving TXS //
    ////////////////////////////////////////////////////
    //
    ////////////////////////////////////////////////////
    // ON CONFIRMATION === process on-chain transactions
    ////////////////////////////////////////////////////
  }, {
    key: "onConfirmation",
    value: function () {
      var _onConfirmation = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(blk, tx, conf) {
        var txmsg, arcade_self, _txmsg$step, step, _t4;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.p = _context11.n) {
            case 0:
              txmsg = tx.returnMessage();
              arcade_self = this.app.modules.returnModule('Arcade');
              if (!(Number(conf) == 0)) {
                _context11.n = 14;
                break;
              }
              _context11.p = 1;
              if (!(txmsg.module === 'Arcade')) {
                _context11.n = 8;
                break;
              }
              if (!this.hasSeenTransaction(tx, Number(blk.id))) {
                _context11.n = 2;
                break;
              }
              return _context11.a(2);
            case 2:
              if (!(txmsg.request === 'open' || txmsg.request === 'private')) {
                _context11.n = 3;
                break;
              }
              _context11.n = 3;
              return arcade_self.receiveOpenTransaction(tx, blk);
            case 3:
              if (!(txmsg.request == 'join')) {
                _context11.n = 4;
                break;
              }
              _context11.n = 4;
              return arcade_self.receiveJoinTransaction(tx);
            case 4:
              if (!(txmsg.request == 'leave')) {
                _context11.n = 5;
                break;
              }
              _context11.n = 5;
              return arcade_self.receiveLeaveTransaction(tx);
            case 5:
              if (!(txmsg.request == 'cancel')) {
                _context11.n = 6;
                break;
              }
              _context11.n = 6;
              return arcade_self.receiveCancelTransaction(tx);
            case 6:
              if (!(txmsg.request === 'accept')) {
                _context11.n = 7;
                break;
              }
              _context11.n = 7;
              return arcade_self.receiveAcceptTransaction(tx);
            case 7:
              _context11.n = 12;
              break;
            case 8:
              if (!(txmsg.request === 'stopgame')) {
                _context11.n = 9;
                break;
              }
              _context11.n = 9;
              return arcade_self.receiveCloseTransaction(tx);
            case 9:
              if (!(txmsg.request === 'gameover')) {
                _context11.n = 10;
                break;
              }
              _context11.n = 10;
              return arcade_self.receiveGameoverTransaction(tx);
            case 10:
              if (!(txmsg.request === 'game')) {
                _context11.n = 11;
                break;
              }
              _context11.n = 11;
              return arcade_self.receiveGameStepTransaction(tx);
            case 11:
              if (this.app.BROWSER) {
                _context11.n = 12;
                break;
              }
              step = (txmsg === null || txmsg === void 0 || (_txmsg$step = txmsg.step) === null || _txmsg$step === void 0 ? void 0 : _txmsg$step.game) || txmsg.step || null;
              if (step) {
                step = String(step).padStart(5, '0');
              }
              console.log('SAVING GAME MOVE: ');
              _context11.n = 12;
              return this.app.storage.saveTransaction(tx, {
                field4: txmsg.game_id,
                field5: step,
                field5_sort: 1
              }, 'localhost');
            case 12:
              //
              // only servers notify lite-clients
              // Added this so cross-network onChain messages can duplicate quickly
              //
              if (this.app.BROWSER == 0 && this.app.SPVMODE == 0) {
                this.notifyPeers(tx);
              }
              _context11.n = 14;
              break;
            case 13:
              _context11.p = 13;
              _t4 = _context11.v;
            case 14:
              return _context11.a(2);
          }
        }, _callee10, this, [[1, 13]]);
      }));
      function onConfirmation(_x12, _x13, _x14) {
        return _onConfirmation.apply(this, arguments);
      }
      return onConfirmation;
    }() /////////////////////////////
    // HANDLE PEER TRANSACTION //
    /////////////////////////////
    //
    // handles off-chain transactions, packaged as data by Relay module
    //
  }, {
    key: "handlePeerTransaction",
    value: function () {
      var _handlePeerTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(app) {
        var newtx,
          peer,
          mycallback,
          message,
          requester,
          txs,
          peers,
          id,
          record,
          g,
          tx,
          txmsg,
          _args12 = arguments,
          _t5,
          _t6;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.n) {
            case 0:
              newtx = _args12.length > 1 && _args12[1] !== undefined ? _args12[1] : null;
              peer = _args12.length > 2 ? _args12[2] : undefined;
              mycallback = _args12.length > 3 && _args12[3] !== undefined ? _args12[3] : null;
              if (!(newtx == null)) {
                _context12.n = 1;
                break;
              }
              return _context12.a(2, 0);
            case 1:
              message = newtx.returnMessage();
              requester = peer.publicKey;
              if (!(message.request === 'arcade invite list')) {
                _context12.n = 7;
                break;
              }
              this.purge();
              txs = [];
              _context12.n = 2;
              return app.network.getPeers();
            case 2:
              peers = _context12.v;
              _t5 = _regeneratorKeys(this.games);
            case 3:
              if ((_t6 = _t5()).done) {
                _context12.n = 6;
                break;
              }
              id = _t6.value;
              record = this.games[id];
              if (!(record.is_sender_reachable !== true && requester != record.tx.from[0].publicKey)) {
                _context12.n = 4;
                break;
              }
              return _context12.a(3, 3);
            case 4:
              if (!(record.status === "closed" || record.status === "over")) {
                _context12.n = 5;
                break;
              }
              return _context12.a(3, 3);
            case 5:
              g = record.tx;
              txs.push(g.serialize_to_web(this.app));
              _context12.n = 3;
              break;
            case 6:
              if (!mycallback) {
                _context12.n = 7;
                break;
              }
              mycallback(txs);
              return _context12.a(2, 1);
            case 7:
              if (!(message.request === 'arcade clear invite')) {
                _context12.n = 8;
                break;
              }
              this.removeGame(message.data.game_id);
              return _context12.a(2, 1);
            case 8:
              if (!(message !== null && message !== void 0 && message.data && (message === null || message === void 0 ? void 0 : message.request) === 'arcade spv update')) {
                _context12.n = 19;
                break;
              }
              tx = new Transaction(undefined, message.data);
              this.hasSeenTransaction(tx);
              txmsg = tx.returnMessage();
              if (!(txmsg.module === 'Arcade')) {
                _context12.n = 15;
                break;
              }
              if (!(txmsg.request === 'open' || txmsg.request === 'private')) {
                _context12.n = 9;
                break;
              }
              _context12.n = 9;
              return this.receiveOpenTransaction(tx);
            case 9:
              if (!(txmsg.request == 'join')) {
                _context12.n = 10;
                break;
              }
              _context12.n = 10;
              return this.receiveJoinTransaction(tx);
            case 10:
              if (!(txmsg.request == 'leave')) {
                _context12.n = 11;
                break;
              }
              _context12.n = 11;
              return this.receiveLeaveTransaction(tx);
            case 11:
              if (!(txmsg.request == 'cancel')) {
                _context12.n = 12;
                break;
              }
              _context12.n = 12;
              return this.receiveCancelTransaction(tx);
            case 12:
              if (!(txmsg.request === 'accept')) {
                _context12.n = 13;
                break;
              }
              _context12.n = 13;
              return this.receiveAcceptTransaction(tx);
            case 13:
              //TODO - reimplement / check
              // This was an idea to completely off-chain send a player a direct/play now game invite
              // Which will pop up a yes/no demand for immediate response

              if (txmsg.request == 'challenge') {
                this.receiveChallengeTransaction(tx);
              }
              if (txmsg.request == 'sorry') {
                //Trigger UI update in game
                app.connection.emit('arcade-reject-challenge', txmsg.game_id);
              }
              if (!(txmsg.request === 'arcade update peer status')) {
                _context12.n = 14;
                break;
              }
              _context12.n = 14;
              return this.receivePeerStatusUpdateTransaction(tx);
            case 14:
              _context12.n = 18;
              break;
            case 15:
              if (!(txmsg.request === 'stopgame')) {
                _context12.n = 16;
                break;
              }
              _context12.n = 16;
              return this.receiveCloseTransaction(tx);
            case 16:
              if (!(txmsg.request === 'gameover')) {
                _context12.n = 17;
                break;
              }
              _context12.n = 17;
              return this.receiveGameoverTransaction(tx);
            case 17:
              if (!this.app.BROWSER) {
                _context12.n = 18;
                break;
              }
              if (!(txmsg.request === 'game')) {
                _context12.n = 18;
                break;
              }
              _context12.n = 18;
              return this.receiveGameStepTransaction(tx);
            case 18:
              //
              // only servers notify lite-clients
              //
              if (app.BROWSER == 0 && app.SPVMODE == 0) {
                this.notifyPeers(tx);
              }
              return _context12.a(2, 1);
            case 19:
              return _context12.a(2, _superPropGet(Arcade, "handlePeerTransaction", this, 3)([app, newtx, peer, mycallback]));
          }
        }, _callee11, this);
      }));
      function handlePeerTransaction(_x15) {
        return _handlePeerTransaction.apply(this, arguments);
      }
      return handlePeerTransaction;
    }()
  }, {
    key: "onConnectionUnstable",
    value: function () {
      var _onConnectionUnstable = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(app, publicKey) {
        var newtx, id, record;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.n) {
            case 0:
              if (!(this.app.BROWSER == 1)) {
                _context13.n = 1;
                break;
              }
              return _context13.a(2);
            case 1:
              _context13.n = 2;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee();
            case 2:
              newtx = _context13.v;
              newtx.msg = {
                module: 'Arcade',
                request: 'arcade update peer status',
                data: {
                  publickey: publicKey,
                  status: 'offline'
                }
              };
              _context13.n = 3;
              return newtx.sign();
            case 3:
              this.notifyPeers(newtx);
              for (id in this.games) {
                record = this.games[id];
                if (record.tx.from[0].publicKey === publicKey) {
                  record.is_sender_reachable = false;
                }
              }
            case 4:
              return _context13.a(2);
          }
        }, _callee12, this);
      }));
      function onConnectionUnstable(_x16, _x17) {
        return _onConnectionUnstable.apply(this, arguments);
      }
      return onConnectionUnstable;
    }() //
    // send TX to our SPV peers
    //
  }, {
    key: "notifyPeers",
    value: function () {
      var _notifyPeers = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(tx) {
        var peers, _iterator6, _step6, peer, message;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.n) {
            case 0:
              if (!(this.app.BROWSER == 1)) {
                _context14.n = 1;
                break;
              }
              return _context14.a(2);
            case 1:
              _context14.n = 2;
              return this.app.network.getPeers();
            case 2:
              peers = _context14.v;
              _iterator6 = _createForOfIteratorHelper(peers);
              try {
                for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                  peer = _step6.value;
                  if (peer.synctype == 'lite' && (peer === null || peer === void 0 ? void 0 : peer.status) !== 'disconnected') {
                    //
                    // fwd tx to peer
                    //
                    message = {};
                    message.request = 'arcade spv update';
                    message.data = tx.toJson();
                    this.app.network.sendRequestAsTransaction(message.request, message.data, null, peer.publicKey);
                  }
                }
              } catch (err) {
                _iterator6.e(err);
              } finally {
                _iterator6.f();
              }
            case 3:
              return _context14.a(2);
          }
        }, _callee13, this);
      }));
      function notifyPeers(_x18) {
        return _notifyPeers.apply(this, arguments);
      }
      return notifyPeers;
    }() ///////////////////////
    // GAME TRANSACTIONS //
    ///////////////////////
    //
    // open - creating games
    // join - adds player, but does not initialize
    // accept - the final player to join, triggers initialization
    //
    ///////////////
    // OPEN GAME //
    ///////////////
    //
    // an OPEN transaction is the first step in creating a game. It describes the
    // conditions of the game and triggers browsers to add it to their list of
    // available games.
    //
    // servers can also index the transaction to notify others that a game is
    // available if asked.
    //
  }, {
    key: "createOpenTransaction",
    value: function () {
      var _createOpenTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(gamedata) {
        var sendto, moduletype, ts, name, options, players_needed, invitation_type, accept_sig, newtx, _t7, _t8;
        return _regenerator().w(function (_context15) {
          while (1) switch (_context15.n) {
            case 0:
              sendto = this.publicKey;
              moduletype = 'Arcade';
              ts = gamedata.ts, name = gamedata.name, options = gamedata.options, players_needed = gamedata.players_needed, invitation_type = gamedata.invitation_type;
              console.log("GAMEDATA: " + JSON.stringify(gamedata));
              _t7 = this.app.crypto;
              _t8 = "invite_game_".concat(ts);
              _context15.n = 1;
              return this.app.wallet.getPrivateKey();
            case 1:
              _context15.n = 2;
              return _t7.signMessage.call(_t7, _t8, _context15.v);
            case 2:
              accept_sig = _context15.v;
              _context15.n = 3;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee();
            case 3:
              newtx = _context15.v;
              newtx.addTo(this.publicKey);
              if (options !== null && options !== void 0 && options.desired_opponent_publickey) {
                newtx.addTo(options.desired_opponent_publickey);
              }
              newtx.msg = {
                timestamp: ts,
                module: moduletype,
                request: invitation_type,
                game: name,
                options: options,
                players_needed: parseInt(players_needed),
                players: [this.publicKey],
                players_sigs: [accept_sig],
                originator: this.publicKey
              };
              _context15.n = 4;
              return newtx.sign();
            case 4:
              return _context15.a(2, newtx);
          }
        }, _callee14, this);
      }));
      function createOpenTransaction(_x19) {
        return _createOpenTransaction.apply(this, arguments);
      }
      return createOpenTransaction;
    }()
  }, {
    key: "receiveOpenTransaction",
    value: function () {
      var _receiveOpenTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(tx) {
        var _txmsg$options;
        var blk,
          txmsg,
          _args16 = arguments;
        return _regenerator().w(function (_context16) {
          while (1) switch (_context16.n) {
            case 0:
              blk = _args16.length > 1 && _args16[1] !== undefined ? _args16[1] : null;
              txmsg = tx.returnMessage(); // add to games list == open or private
              this.addGame(tx);
              this.renderInvites();
              if (!tx.isFrom(this.publicKey)) {
                _context16.n = 1;
                break;
              }
              clearTimeout(this.game_timeout);
              if (this.app.browser.isMobileBrowser(navigator.userAgent) && !this.browser_active) {
                siteMessage('Game invite created', 1000);
              } else {
                if (txmsg.request == 'private') {
                  this.showShareLink(tx.signature);
                }
              }
              return _context16.a(2);
            case 1:
              if ((txmsg === null || txmsg === void 0 || (_txmsg$options = txmsg.options) === null || _txmsg$options === void 0 ? void 0 : _txmsg$options.desired_opponent_publickey) == this.publicKey) {
                siteMessage("You were invited to play ".concat(txmsg.game), 5000);
              }
            case 2:
              return _context16.a(2);
          }
        }, _callee15, this);
      }));
      function receiveOpenTransaction(_x20) {
        return _receiveOpenTransaction.apply(this, arguments);
      }
      return receiveOpenTransaction;
    }()
  }, {
    key: "createCancelTransaction",
    value: function () {
      var _createCancelTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16(orig_tx) {
        var newtx, _iterator7, _step7, player, msg;
        return _regenerator().w(function (_context17) {
          while (1) switch (_context17.n) {
            case 0:
              _context17.n = 1;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee();
            case 1:
              newtx = _context17.v;
              _iterator7 = _createForOfIteratorHelper(orig_tx.msg.players);
              try {
                for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                  player = _step7.value;
                  newtx.addTo(player);
                }
              } catch (err) {
                _iterator7.e(err);
              } finally {
                _iterator7.f();
              }
              newtx.addTo(this.publicKey);
              msg = {
                request: 'cancel',
                module: 'Arcade',
                game_id: orig_tx.signature
              };
              newtx.msg = msg;
              _context17.n = 2;
              return newtx.sign();
            case 2:
              return _context17.a(2, newtx);
          }
        }, _callee16, this);
      }));
      function createCancelTransaction(_x21) {
        return _createCancelTransaction.apply(this, arguments);
      }
      return createCancelTransaction;
    }()
  }, {
    key: "receiveCancelTransaction",
    value: function () {
      var _receiveCancelTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17(tx) {
        var _game$tx, _game$tx$msg$options;
        var txmsg, game, p_index;
        return _regenerator().w(function (_context18) {
          while (1) switch (_context18.n) {
            case 0:
              txmsg = tx.returnMessage();
              game = this.returnGame(txmsg.game_id);
              if (!(!game || !((_game$tx = game.tx) !== null && _game$tx !== void 0 && _game$tx.msg))) {
                _context18.n = 1;
                break;
              }
              return _context18.a(2);
            case 1:
              if (game.tx.msg.players.includes(tx.from[0].publicKey)) {
                if (tx.from[0].publicKey == game.tx.msg.originator) {
                  this.changeGameStatus(txmsg.game_id, 'closed');
                } else {
                  p_index = game.tx.msg.players.indexOf(tx.from[0].publicKey);
                  game.tx.msg.players.splice(p_index, 1);
                  //Make sure player_sigs array exists and add invite_sig
                  if (game.tx.msg.players_sigs && game.tx.msg.players_sigs.length > p_index) {
                    game.tx.msg.players_sigs.splice(p_index, 1);
                  }
                }
              } else if ((_game$tx$msg$options = game.tx.msg.options) !== null && _game$tx$msg$options !== void 0 && _game$tx$msg$options.desired_opponent_publickey && tx.isFrom(game.tx.msg.options.desired_opponent_publickey)) {
                if (this.publicKey == game.tx.msg.originator) {
                  siteMessage('Your game invite was declined', 5000);
                }
                this.changeGameStatus(txmsg.game_id, 'closed');
              }
              this.app.connection.emit('arcade-close-game', txmsg.game_id);
              this.renderInvites();
            case 2:
              return _context18.a(2);
          }
        }, _callee17, this);
      }));
      function receiveCancelTransaction(_x22) {
        return _receiveCancelTransaction.apply(this, arguments);
      }
      return receiveCancelTransaction;
    }()
  }, {
    key: "sendCancelTransaction",
    value: function () {
      var _sendCancelTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18(game_id) {
        var _game$tx2;
        var game, close_tx;
        return _regenerator().w(function (_context19) {
          while (1) switch (_context19.n) {
            case 0:
              game = this.returnGame(game_id);
              if (!(!game || !((_game$tx2 = game.tx) !== null && _game$tx2 !== void 0 && _game$tx2.msg))) {
                _context19.n = 1;
                break;
              }
              return _context19.a(2);
            case 1:
              _context19.n = 2;
              return this.createCancelTransaction(game.tx);
            case 2:
              close_tx = _context19.v;
              this.app.network.propagateTransaction(close_tx);
              this.app.connection.emit('relay-send-message', {
                recipient: game.tx.msg.players,
                request: 'arcade spv update',
                data: close_tx.toJson()
              });
              this.app.connection.emit('relay-send-message', {
                recipient: 'PEERS',
                request: 'arcade spv update',
                data: close_tx.toJson()
              });
            case 3:
              return _context19.a(2);
          }
        }, _callee18, this);
      }));
      function sendCancelTransaction(_x23) {
        return _sendCancelTransaction.apply(this, arguments);
      }
      return sendCancelTransaction;
    }()
  }, {
    key: "changeGameStatus",
    value: function changeGameStatus(game_id, newStatus) {
      var game = this.returnGame(game_id);

      //Move game to different list
      if (game) {
        if (this.sudo) {
          console.debug("ARCADE: Change game (".concat(game_id.substring(0, 10), "...) status from ").concat(game.tx.msg.request, " to ").concat(newStatus));
        }
        if (!(this !== null && this !== void 0 && this.sudo)) {
          var _game$tx3, _game$tx4;
          if (((_game$tx3 = game.tx) === null || _game$tx3 === void 0 || (_game$tx3 = _game$tx3.msg) === null || _game$tx3 === void 0 ? void 0 : _game$tx3.request) == 'over' || ((_game$tx4 = game.tx) === null || _game$tx4 === void 0 || (_game$tx4 = _game$tx4.msg) === null || _game$tx4 === void 0 ? void 0 : _game$tx4.request) == 'closed') {
            return;
          }
        }
        this.removeGame(game_id);
        this.addGame(game.tx, newStatus);
      }
      this.renderInvites();
    }
  }, {
    key: "receiveGameoverTransaction",
    value: function () {
      var _receiveGameoverTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19(tx) {
        var _game$tx5;
        var txmsg, game, winner;
        return _regenerator().w(function (_context20) {
          while (1) switch (_context20.n) {
            case 0:
              txmsg = tx.returnMessage();
              game = this.returnGame(txmsg.game_id); //In case we arrive at gameover without close game
              this.app.connection.emit('arcade-close-game', txmsg.game_id);
              this.changeGameStatus(txmsg.game_id, 'over');
              winner = txmsg.winner || null;
              if (game !== null && game !== void 0 && (_game$tx5 = game.tx) !== null && _game$tx5 !== void 0 && _game$tx5.msg) {
                //Store the results locally
                game.tx.msg.winner = winner;
                game.tx.msg.method = txmsg.reason;
                game.tx.msg.time_finished = txmsg.timestamp;
              } else {
                console.warn("Game not found, arcade can't process gameover tx");
              }
            case 1:
              return _context20.a(2);
          }
        }, _callee19, this);
      }));
      function receiveGameoverTransaction(_x24) {
        return _receiveGameoverTransaction.apply(this, arguments);
      }
      return receiveGameoverTransaction;
    }()
  }, {
    key: "receiveCloseTransaction",
    value: function () {
      var _receiveCloseTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee20(tx) {
        var txmsg;
        return _regenerator().w(function (_context21) {
          while (1) switch (_context21.n) {
            case 0:
              txmsg = tx.returnMessage(); // Mark game as closed, unless it is a player leaving an open table...
              if (txmsg.reason !== 'withdraw') {
                this.app.connection.emit('arcade-close-game', txmsg.game_id);
                this.changeGameStatus(txmsg.game_id, 'closed');
              }
            case 1:
              return _context21.a(2);
          }
        }, _callee20, this);
      }));
      function receiveCloseTransaction(_x25) {
        return _receiveCloseTransaction.apply(this, arguments);
      }
      return receiveCloseTransaction;
    }()
  }, {
    key: "receiveGameStepTransaction",
    value: function () {
      var _receiveGameStepTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee21(tx) {
        var _game$tx6;
        var txmsg, game;
        return _regenerator().w(function (_context22) {
          while (1) switch (_context22.n) {
            case 0:
              txmsg = tx.returnMessage();
              game = this.returnGame(txmsg.game_id);
              if (game !== null && game !== void 0 && (_game$tx6 = game.tx) !== null && _game$tx6 !== void 0 && _game$tx6.msg) {
                game.tx.msg.step = txmsg.step.game;
                game.tx.msg.timestamp = txmsg.step.timestamp;
              }
            case 1:
              return _context22.a(2);
          }
        }, _callee21, this);
      }));
      function receiveGameStepTransaction(_x26) {
        return _receiveGameStepTransaction.apply(this, arguments);
      }
      return receiveGameStepTransaction;
    }() ///////////////
    // JOIN GAME //
    ///////////////
    //
    // join is the act of adding yourself to a game that does not have enough
    // players. technically, you're providing a signature that -- when returned
    // as part of a valid game, will trigger your browser to start initializing
    // the game.
    //
  }, {
    key: "createJoinTransaction",
    value: function () {
      var _createJoinTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee22(orig_tx) {
        var option_update,
          txmsg,
          newtx,
          _iterator8,
          _step8,
          player,
          _args23 = arguments,
          _t9,
          _t0;
        return _regenerator().w(function (_context23) {
          while (1) switch (_context23.n) {
            case 0:
              option_update = _args23.length > 1 && _args23[1] !== undefined ? _args23[1] : null;
              if (!(!orig_tx || !orig_tx.signature)) {
                _context23.n = 1;
                break;
              }
              console.error('ARCADE: Invalid Game Invite TX, cannot Join');
              return _context23.a(2);
            case 1:
              txmsg = orig_tx.returnMessage();
              _context23.n = 2;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee();
            case 2:
              newtx = _context23.v;
              _iterator8 = _createForOfIteratorHelper(txmsg.players);
              try {
                for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                  player = _step8.value;
                  newtx.addTo(player);
                }
              } catch (err) {
                _iterator8.e(err);
              } finally {
                _iterator8.f();
              }
              newtx.addTo(this.publicKey);
              newtx.msg = JSON.parse(JSON.stringify(txmsg));
              newtx.msg.module = 'Arcade';
              newtx.msg.request = 'join';
              newtx.msg.game_id = orig_tx.signature;
              if (option_update) {
                newtx.msg.options = orig_tx.msg.options[option_update];
                newtx.msg.update_options = option_update;
              }
              _t9 = this.app.crypto;
              _t0 = 'invite_game_' + orig_tx.msg.timestamp;
              _context23.n = 3;
              return this.app.wallet.getPrivateKey();
            case 3:
              _context23.n = 4;
              return _t9.signMessage.call(_t9, _t0, _context23.v);
            case 4:
              newtx.msg.invite_sig = _context23.v;
              _context23.n = 5;
              return newtx.sign();
            case 5:
              return _context23.a(2, newtx);
          }
        }, _callee22, this);
      }));
      function createJoinTransaction(_x27) {
        return _createJoinTransaction.apply(this, arguments);
      }
      return createJoinTransaction;
    }()
  }, {
    key: "sendJoinTransaction",
    value: function () {
      var _sendJoinTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee23(invite) {
        var update_options,
          newtx,
          _args24 = arguments;
        return _regenerator().w(function (_context24) {
          while (1) switch (_context24.n) {
            case 0:
              update_options = _args24.length > 1 && _args24[1] !== undefined ? _args24[1] : '';
              _context24.n = 1;
              return this.createJoinTransaction(invite.tx, update_options);
            case 1:
              newtx = _context24.v;
              //
              // send it on-chain and off-chain
              //
              this.app.network.propagateTransaction(newtx);
              this.app.connection.emit('relay-send-message', {
                recipient: 'PEERS',
                request: 'arcade spv update',
                data: newtx.toJson()
              });
              this.renderInvites();
            case 2:
              return _context24.a(2);
          }
        }, _callee23, this);
      }));
      function sendJoinTransaction(_x28) {
        return _sendJoinTransaction.apply(this, arguments);
      }
      return sendJoinTransaction;
    }()
  }, {
    key: "receiveJoinTransaction",
    value: function () {
      var _receiveJoinTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee24(tx) {
        var txmsg, game, _game$tx$msg$options2, newtx;
        return _regenerator().w(function (_context25) {
          while (1) switch (_context25.n) {
            case 0:
              if (!(!tx || !tx.signature)) {
                _context25.n = 1;
                break;
              }
              return _context25.a(2);
            case 1:
              txmsg = tx.returnMessage(); //Transaction must be signed
              if (txmsg.invite_sig) {
                _context25.n = 2;
                break;
              }
              return _context25.a(2);
            case 2:
              //
              // game is the record (tx + state); game.tx is the original invite creation TX.
              //
              game = this.returnGame(txmsg.game_id); //
              // If we don't find it, or we have already marked the game as active, stop processing
              //
              if (game) {
                _context25.n = 3;
                break;
              }
              return _context25.a(2);
            case 3:
              if (!game.state) {
                _context25.n = 4;
                break;
              }
              return _context25.a(2);
            case 4:
              if (game.tx.msg.players.includes(tx.from[0].publicKey)) {
                _context25.n = 6;
                break;
              }
              if (!this.isAvailableGame(game.tx)) {
                _context25.n = 5;
                break;
              }
              if (txmsg.update_options) {
                console.info("ARCADE: Join TX updates the invite options -- ".concat(txmsg.update_options, "!"), game.tx.msg.options, txmsg.options);
                Object.assign(game.tx.msg.options[txmsg.update_options], txmsg.options);
              }

              //
              // add player to game
              //
              game.tx.msg.players.push(tx.from[0].publicKey);
              game.tx.msg.players_sigs.push(txmsg.invite_sig);
              this.removeGame(txmsg.game_id);
              this.addGame(game.tx);
              this.renderInvites();
              _context25.n = 6;
              break;
            case 5:
              if (!tx.isFrom(this.publicKey)) {
                _context25.n = 6;
                break;
              }
              salert('Game not available right now...');
              return _context25.a(2);
            case 6:
              if (!(game.tx.msg.request == 'active' || game.tx.msg.request == 'over')) {
                _context25.n = 7;
                break;
              }
              return _context25.a(2);
            case 7:
              if (!game.state) {
                _context25.n = 8;
                break;
              }
              return _context25.a(2);
            case 8:
              if (!(game.tx.msg.players.length >= game.tx.msg.players_needed && game.tx.msg.request !== 'accepted' && game.tx.msg.request !== 'active')) {
                _context25.n = 11;
                break;
              }
              //
              // Temporarily change it so we don't process additional joins
              //
              game.tx.msg.request = 'accepted';

              //
              // First player (originator) sends the accept message
              //
              if (!(game.tx.msg.originator == this.publicKey || tx.isFrom(this.publicKey) && (_game$tx$msg$options2 = game.tx.msg.options) !== null && _game$tx$msg$options2 !== void 0 && _game$tx$msg$options2.async_dealing)) {
                _context25.n = 11;
                break;
              }
              _context25.n = 9;
              return this.createAcceptTransaction(game.tx);
            case 9:
              newtx = _context25.v;
              if (newtx) {
                _context25.n = 10;
                break;
              }
              console.warn('ARCADE: createAcceptTransaction returned nothing; skipping propagate and lounge overlay');
              return _context25.a(2);
            case 10:
              this.app.network.propagateTransaction(newtx);
              this.app.connection.emit('relay-send-message', {
                recipient: 'PEERS',
                request: 'arcade spv update',
                data: newtx.toJson()
              });

              //Start Spinner
              this.render('lounge_overlay', {
                game_id: txmsg.game_id
              });
            case 11:
              return _context25.a(2);
          }
        }, _callee24, this);
      }));
      function receiveJoinTransaction(_x29) {
        return _receiveJoinTransaction.apply(this, arguments);
      }
      return receiveJoinTransaction;
    }()
  }, {
    key: "sendLeaveTransaction",
    value: function () {
      var _sendLeaveTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee25(invite_tx, data) {
        var txmsg, newtx, _iterator9, _step9, player;
        return _regenerator().w(function (_context26) {
          while (1) switch (_context26.n) {
            case 0:
              txmsg = invite_tx.returnMessage();
              _context26.n = 1;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee();
            case 1:
              newtx = _context26.v;
              _iterator9 = _createForOfIteratorHelper(txmsg.players);
              try {
                for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                  player = _step9.value;
                  newtx.addTo(player);
                }
              } catch (err) {
                _iterator9.e(err);
              } finally {
                _iterator9.f();
              }
              newtx.addTo(this.publicKey);
              newtx.msg = JSON.parse(JSON.stringify(txmsg));
              newtx.msg.module = 'Arcade';
              newtx.msg.request = 'leave';
              newtx.msg.game_id = invite_tx.signature;
              newtx.msg.data = data;
              _context26.n = 2;
              return newtx.sign();
            case 2:
              this.app.network.propagateTransaction(newtx);
              this.app.connection.emit('relay-send-message', {
                recipient: 'PEERS',
                request: 'arcade spv update',
                data: newtx.toJson()
              });
              this.renderInvites();
            case 3:
              return _context26.a(2);
          }
        }, _callee25, this);
      }));
      function sendLeaveTransaction(_x30, _x31) {
        return _sendLeaveTransaction.apply(this, arguments);
      }
      return sendLeaveTransaction;
    }()
  }, {
    key: "receiveLeaveTransaction",
    value: function () {
      var _receiveLeaveTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee26(tx) {
        var txmsg, game, _game$tx$msg$options3, index;
        return _regenerator().w(function (_context27) {
          while (1) switch (_context27.n) {
            case 0:
              if (!(!tx || !tx.signature)) {
                _context27.n = 1;
                break;
              }
              return _context27.a(2);
            case 1:
              txmsg = tx.returnMessage(); //
              // game is the record (tx + status + state) for the invite.
              //
              game = this.returnGame(txmsg.game_id); //
              // If we don't find it, or we have already marked the game as active, stop processing
              //
              if (game) {
                _context27.n = 2;
                break;
              }
              return _context27.a(2);
            case 2:
              //
              // Don't remove the same player twice!
              //
              if (game.tx.msg.players.includes(tx.from[0].publicKey)) {
                index = game.tx.msg.players.indexOf(tx.from[0].publicKey);
                game.tx.msg.players.splice(index, 1);
                game.tx.msg.players_sigs.splice(index, 1);
                if (!((_game$tx$msg$options3 = game.tx.msg.options) !== null && _game$tx$msg$options3 !== void 0 && _game$tx$msg$options3.eliminated)) {
                  game.tx.msg.options.eliminated = {};
                }
                game.tx.msg.options.eliminated[tx.from[0].publicKey] = txmsg.data;
                this.removeGame(txmsg.game_id);
                this.addGame(game.tx);
                this.renderInvites();
              }
            case 3:
              return _context27.a(2);
          }
        }, _callee26, this);
      }));
      function receiveLeaveTransaction(_x32) {
        return _receiveLeaveTransaction.apply(this, arguments);
      }
      return receiveLeaveTransaction;
    }() /////////////////
    // ACCEPT GAME //
    /////////////////
    //
    // this transaction should be a valid game that has signatures from everyone
    // and is capable of initializing a game. if this TX is valid and has our
    // signature we will auto-accept it, kicking off the game.
    //
  }, {
    key: "createAcceptTransaction",
    value: function () {
      var _createAcceptTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee27(orig_tx) {
        var txmsg, newtx, i;
        return _regenerator().w(function (_context28) {
          while (1) switch (_context28.n) {
            case 0:
              if (!(!orig_tx || !orig_tx.signature)) {
                _context28.n = 1;
                break;
              }
              console.error('ARCADE: Invalid Game Invite TX, cannot Accept');
              return _context28.a(2);
            case 1:
              // Use returnMessage() so we get the full message even if tx was deserialized (lazy .msg)
              txmsg = orig_tx.returnMessage();
              if (!(!txmsg || !txmsg.players || txmsg.players.length === 0)) {
                _context28.n = 2;
                break;
              }
              console.error('ARCADE: createAcceptTransaction -- invalid or empty message from orig_tx', orig_tx.signature);
              return _context28.a(2);
            case 2:
              // Provide originator if missing: open-invite creator is always the first player
              if (txmsg.originator == null || txmsg.originator === '') {
                txmsg.originator = txmsg.players[0];
              }
              _context28.n = 3;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee();
            case 3:
              newtx = _context28.v;
              for (i = 0; i < txmsg.players.length; i++) {
                newtx.addTo(txmsg.players[i]);
              }
              newtx.msg = JSON.parse(JSON.stringify(txmsg));
              newtx.msg.module = 'Arcade';
              newtx.msg.game_id = orig_tx.signature;
              newtx.msg.request = 'accept';
              _context28.n = 4;
              return newtx.sign();
            case 4:
              return _context28.a(2, newtx);
          }
        }, _callee27, this);
      }));
      function createAcceptTransaction(_x33) {
        return _createAcceptTransaction.apply(this, arguments);
      }
      return createAcceptTransaction;
    }()
  }, {
    key: "receiveAcceptTransaction",
    value: function () {
      var _receiveAcceptTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee28(tx) {
        var _txmsg$options2;
        var txmsg, gamemod, game, i, _this$app, game_engine_id;
        return _regenerator().w(function (_context29) {
          while (1) switch (_context29.n) {
            case 0:
              if (tx) {
                _context29.n = 1;
                break;
              }
              console.error('ARCADE: Invalid Accept tx');
              return _context29.a(2);
            case 1:
              txmsg = tx.returnMessage();
              if (txmsg) {
                _context29.n = 2;
                break;
              }
              console.error('ARCADE: receiveAcceptTransaction -- tx.returnMessage() is null; cannot initialize', tx === null || tx === void 0 ? void 0 : tx.signature);
              return _context29.a(2);
            case 2:
              if (!(txmsg.originator == null || txmsg.originator === '')) {
                _context29.n = 3;
                break;
              }
              console.error('ARCADE: receiveAcceptTransaction -- originator missing in accept tx; refusing to pass to game engine', txmsg.game_id);
              return _context29.a(2);
            case 3:
              //
              // Must have game module installed
              // We call the game-initialization function directly on gamemod further down
              //
              gamemod = this.app.modules.returnModule(txmsg.game); // I guess this safety catch should be further up the processing chain, like we shouldn't even display an invite/join a game we don't have installed
              if (gamemod) {
                _context29.n = 4;
                break;
              }
              console.error('ARCADE Error Initializing! Game Module not Installed -- ' + txmsg.game);
              return _context29.a(2);
            case 4:
              game = this.returnGame(txmsg.game_id); // Must be an available invite
              if (!(!game || !this.isAvailableGame(game.tx, 'accepted') && !((_txmsg$options2 = txmsg.options) !== null && _txmsg$options2 !== void 0 && _txmsg$options2.async_dealing))) {
                _context29.n = 5;
                break;
              }
              return _context29.a(2);
            case 5:
              i = 0;
            case 6:
              if (!(i < ((_this$app = this.app) === null || _this$app === void 0 || (_this$app = _this$app.options) === null || _this$app === void 0 || (_this$app = _this$app.games) === null || _this$app === void 0 ? void 0 : _this$app.length))) {
                _context29.n = 8;
                break;
              }
              if (!(this.app.options.games[i].id === txmsg.game_id)) {
                _context29.n = 7;
                break;
              }
              console.debug('ARCADE: [receiveAcceptTX] game already accepted and in my options');
              return _context29.a(2);
            case 7:
              i++;
              _context29.n = 6;
              break;
            case 8:
              if (!game.state) {
                _context29.n = 9;
                break;
              }
              return _context29.a(2);
            case 9:
              //
              // Mark the game as accept, i.e. active
              //
              this.changeGameStatus(txmsg.game_id, 'active');

              //
              // If I am a player in the game, let's start it initializing
              //
              if (!txmsg.players.includes(this.publicKey)) {
                _context29.n = 12;
                break;
              }
              if (!this.app.options.arcade[txmsg.game]) {
                this.app.options.arcade[txmsg.game] = 0;
              }
              this.app.options.arcade[txmsg.game]++;
              this.app.options.arcade.last_game = txmsg.game;
              _context29.n = 10;
              return this.render('lounge_overlay', {
                game_id: txmsg.game_id
              });
            case 10:
              if (this.app.BROWSER == 1 && txmsg.players.length > 1) {
                siteMessage(txmsg.game + ' invite accepted', 5000);
              }
              _context29.n = 11;
              return gamemod.initializeGameFromAcceptTransaction(tx);
            case 11:
              game_engine_id = _context29.v;
              if (!game_engine_id || game_engine_id !== txmsg.game_id) {
                salert('Something went wrong with the game initialization: ' + game_engine_id);
              }
            case 12:
              return _context29.a(2);
          }
        }, _callee28, this);
      }));
      function receiveAcceptTransaction(_x34) {
        return _receiveAcceptTransaction.apply(this, arguments);
      }
      return receiveAcceptTransaction;
    }()
  }, {
    key: "receivePeerStatusUpdateTransaction",
    value: function () {
      var _receivePeerStatusUpdateTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee29(tx) {
        var _txmsg$data, _txmsg$data2;
        var txmsg, pk, status, id, record;
        return _regenerator().w(function (_context30) {
          while (1) switch (_context30.n) {
            case 0:
              txmsg = tx.returnMessage();
              pk = (_txmsg$data = txmsg.data) === null || _txmsg$data === void 0 ? void 0 : _txmsg$data.publickey;
              status = (_txmsg$data2 = txmsg.data) === null || _txmsg$data2 === void 0 ? void 0 : _txmsg$data2.status;
              if (!(!pk || !status)) {
                _context30.n = 1;
                break;
              }
              return _context30.a(2, 0);
            case 1:
              for (id in this.games) {
                record = this.games[id];
                if (record.tx.from[0].publicKey === pk) {
                  record.is_sender_reachable = status === 'online';
                }
              }
              if (this.app.BROWSER) {
                this.renderInvites();
              }
              return _context30.a(2, 0);
          }
        }, _callee29, this);
      }));
      function receivePeerStatusUpdateTransaction(_x35) {
        return _receivePeerStatusUpdateTransaction.apply(this, arguments);
      }
      return receivePeerStatusUpdateTransaction;
    }()
  }, {
    key: "createChallengeTransaction",
    value: function () {
      var _createChallengeTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee30(game, players, options) {
        var timestamp, accept_sig, tx, otherPlayer, _iterator0, _step0, sendto, _t1, _t10;
        return _regenerator().w(function (_context31) {
          while (1) switch (_context31.n) {
            case 0:
              timestamp = new Date().getTime();
              _t1 = this.app.crypto;
              _t10 = "invite_game_".concat(timestamp);
              _context31.n = 1;
              return this.app.wallet.getPrivateKey();
            case 1:
              _context31.n = 2;
              return _t1.signMessage.call(_t1, _t10, _context31.v);
            case 2:
              accept_sig = _context31.v;
              _context31.n = 3;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(this.publicKey);
            case 3:
              tx = _context31.v;
              otherPlayer = null;
              console.debug("ARCADE: direct challenge player -- ", players);
              _iterator0 = _createForOfIteratorHelper(players);
              try {
                for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
                  sendto = _step0.value;
                  if (sendto !== this.publicKey) {
                    otherPlayer = sendto;
                    tx.addTo(otherPlayer);
                  }
                }
              } catch (err) {
                _iterator0.e(err);
              } finally {
                _iterator0.f();
              }
              if (otherPlayer) {
                _context31.n = 4;
                break;
              }
              return _context31.a(2, null);
            case 4:
              tx.msg = {
                timestamp: timestamp,
                module: 'Arcade',
                request: 'challenge',
                game: game,
                options: options,
                players_needed: players.length,
                players: [this.publicKey],
                players_sigs: [accept_sig],
                originator: this.publicKey,
                desired_opponent_publickey: otherPlayer
              };
              _context31.n = 5;
              return tx.sign();
            case 5:
              return _context31.a(2, tx);
          }
        }, _callee30, this);
      }));
      function createChallengeTransaction(_x36, _x37, _x38) {
        return _createChallengeTransaction.apply(this, arguments);
      }
      return createChallengeTransaction;
    }()
  }, {
    key: "receiveChallengeTransaction",
    value: function receiveChallengeTransaction(tx) {
      var blk = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (!tx || !tx.signature) {
        return;
      }
      if (!tx.isTo(this.publicKey)) {
        return;
      }
      this.addGame(tx, 'private');
      var txmsg = tx.returnMessage();
      console.debug('ARCADE: receive challenge transaction', tx);
      if (!tx.isFrom(this.publicKey)) {
        this.challenge_tx = tx;
      }
      this.app.connection.emit('arcade-challenge-issued', tx);
    }

    ///////////////////////////////
    // "LOAD"ING AND RUNNING GAMES //
    ///////////////////////////////
    //
    // single player game
    //
  }, {
    key: "launchSinglePlayerGame",
    value: function () {
      var _launchSinglePlayerGame = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee31(gameobj) {
        var opentx, newtx;
        return _regenerator().w(function (_context32) {
          while (1) switch (_context32.n) {
            case 0:
              _context32.n = 1;
              return this.createOpenTransaction(gameobj);
            case 1:
              opentx = _context32.v;
              this.app.connection.emit('relay-send-message', {
                recipient: 'PEERS',
                request: 'arcade spv update',
                data: opentx.toJson()
              });
              this.addGame(opentx, 'private');
              _context32.n = 2;
              return this.createAcceptTransaction(opentx);
            case 2:
              newtx = _context32.v;
              if (newtx) {
                _context32.n = 3;
                break;
              }
              console.warn('ARCADE: launchSinglePlayerGame -- createAcceptTransaction returned nothing');
              return _context32.a(2);
            case 3:
              this.app.network.propagateTransaction(newtx);
              this.app.connection.emit('relay-send-message', {
                recipient: 'PEERS',
                request: 'arcade spv update',
                data: newtx.toJson()
              });

              //Start Spinner
              this.render('lounge_overlay', {
                game_id: opentx.signature
              });
            case 4:
              return _context32.a(2);
          }
        }, _callee31, this);
      }));
      function launchSinglePlayerGame(_x39) {
        return _launchSinglePlayerGame.apply(this, arguments);
      }
      return launchSinglePlayerGame;
    }()
  }, {
    key: "addGame",
    value: function addGame(tx) {
      var list = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (!tx || !tx.msg || !tx.signature) {
        // console.error("ARCADE: [addGame] Invalid Game TX, won't add to list", tx);
        return false;
      }
      if (this.games[tx.signature]) {
        return false;
      }
      if (list) {
        // status from caller
      } else {
        var _tx$msg;
        list = ((_tx$msg = tx.msg) === null || _tx$msg === void 0 ? void 0 : _tx$msg.request) || 'open';
      }
      if (list !== 'over' && !list.includes('close')) {
        if (this.isMyGame(tx)) {
          list = 'mine';
        } else {
          if (tx.msg.players_needed <= tx.msg.players.length) {
            list = 'active';
          }
        }
      }
      this.games[tx.signature] = {
        tx: tx,
        status: list,
        updated_at: Date.now(),
        is_sender_reachable: true
      };
      return true;
    }
  }, {
    key: "removeGame",
    value: function removeGame(game_id) {
      delete this.games[game_id];
    }
  }, {
    key: "returnGame",
    value: function returnGame(game_id) {
      var _this$app$options2;
      var record = this.games[game_id] || null;
      if (!record) return null;
      var engineState = ((_this$app$options2 = this.app.options) === null || _this$app$options2 === void 0 || (_this$app$options2 = _this$app$options2.games) === null || _this$app$options2 === void 0 ? void 0 : _this$app$options2.find(function (g) {
        return g.id === game_id;
      })) || null;
      return _objectSpread(_objectSpread({}, record), {}, {
        state: engineState
      });
    }
  }, {
    key: "returnGameTransaction",
    value: function returnGameTransaction(game_id) {
      var record = this.returnGame(game_id);
      if (record.tx) {
        return record.tx;
      }
      return null;
    }
  }, {
    key: "returnGamesWithFilter",
    value: function returnGamesWithFilter(filterObject) {
      return Object.values(this.games).filter(function (record) {
        for (var key in filterObject) {
          if (record[key] !== filterObject[key]) return false;
        }
        return true;
      });
    }
  }, {
    key: "purge",
    value: function purge() {
      var INVITE_CUTOFF = 2000000; // 30 minutes
      var GAME_CUTOFF = 600000000;
      var now = new Date().getTime();
      var walletModified = false;

      // --- Expire open/mine to closed (previous setInterval logic) ---
      for (var _i = 0, _Object$keys = Object.keys(this.games); _i < _Object$keys.length; _i++) {
        var id = _Object$keys[_i];
        var record = this.games[id];
        var g = record.tx;
        if ((record.status === 'mine' || record.status === 'open') && g.timestamp < now - INVITE_CUTOFF) {
          this.removeGame(g.signature);
          this.addGame(g, 'closed');
        }
      }

      // --- Purge this.games by age ---
      for (var _i2 = 0, _Object$keys2 = Object.keys(this.games); _i2 < _Object$keys2.length; _i2++) {
        var _id = _Object$keys2[_i2];
        var _record = this.games[_id];
        var cutoff = now - INVITE_CUTOFF;
        if (_record.status === 'active' || _record.status === 'over' || _record.status === 'mine') {
          cutoff = now - GAME_CUTOFF;
        }
        if (_record.tx.timestamp <= cutoff) {
          delete this.games[_id];
        }
      }
      if (this.app.BROWSER) {
        // Second pass: expire my invites that are not available
        var _cutoff = now - INVITE_CUTOFF;
        for (var _i3 = 0, _Object$keys3 = Object.keys(this.games); _i3 < _Object$keys3.length; _i3++) {
          var _id2 = _Object$keys3[_i3];
          var _record2 = this.games[_id2];
          if (_record2.status !== 'mine') continue;
          if (!this.isAvailableGame(_record2.tx) && _record2.tx.timestamp < _cutoff) {
            siteMessage('Game invite timed out...', 4000);
            delete this.games[_id2];
          }
        }
      }

      // --- Purge malformed wallet games (from purgeBadGamesFromWallet) ---
      if (this.app.options.games) {
        for (var i = this.app.options.games.length - 1; i >= 0; i--) {
          if (this.app.options.games[i].module === '' && this.app.options.games[i].id.length < 25) {
            this.app.options.games.splice(i, 1);
            walletModified = true;
          } else if (this.app.options.games[i].players_set == 0) {
            //This will be games created but not fully initialized for whatever reason
            this.app.options.games.splice(i, 1);
            walletModified = true;
          }
        }
      }

      // --- Purge completed/old wallet games (from purgeOldGamesFromWallet) ---
      if (this.app.options.games) {
        for (var _i4 = this.app.options.games.length - 1; _i4 >= 0; _i4--) {
          var _g = this.app.options.games[_i4];
          if (_g.over >= 1) {
            if (_g.timestamp < now - 240000) {
              // after 1 hour
              this.app.options.games.splice(_i4, 1);
              walletModified = true;
            }
          }
        }
      }
      if (walletModified) {
        this.app.storage.saveOptions();
        this.renderInvites();
      }
    }
  }, {
    key: "removeGameFromWallet",
    value: function removeGameFromWallet(game_id) {
      this.removeGame(game_id);
      if (this.app.options.games) {
        for (var i = 0; i < this.app.options.games.length; i++) {
          if (this.app.options.games[i].id === game_id) {
            this.app.options.games.splice(i, 1);
            break;
          }
        }
      }
      this.app.storage.saveOptions();
      this.renderInvites();
    }
  }, {
    key: "isAvailableGame",
    value: function isAvailableGame(game_tx) {
      var additional_status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      if (game_tx.msg.request == 'open' || game_tx.msg.request == 'private') {
        return true;
      }
      if (game_tx.msg.request == 'active' && game_tx.msg.options['open-table']) {
        return true;
      }
      if (additional_status && additional_status === game_tx.msg.request) {
        return true;
      }
      return false;
    }

    //
    // Determines whether the user is in any way associated with the game
    // Either they sent the invite, they have clicked join, or someone specifically invited them by key
    //
  }, {
    key: "isMyGame",
    value: function isMyGame(tx) {
      for (var i = 0; i < tx.to.length; i++) {
        if (tx.to[i].publicKey == this.publicKey) {
          return true;
        }
      }
      for (var _i5 = 0; _i5 < tx.msg.players.length; _i5++) {
        if (tx.msg.players[_i5] == this.publicKey) {
          return true;
        }
      }
      if (tx.msg.options) {
        if (tx.msg.options.desired_opponent_publickey) {
          if (tx.msg.options.desired_opponent_publickey == this.publicKey) {
            return true;
          }
        }
      }
      return false;
    }
  }, {
    key: "returnOpenInvites",
    value: function returnOpenInvites() {
      var _this6 = this;
      return Object.values(this.games).filter(function (r) {
        return r.status === 'mine' && _this6.isAvailableGame(r.tx) && _this6.publicKey == r.tx.msg.originator;
      }).map(function (r) {
        return r.tx.signature;
      });
    }
  }, {
    key: "shouldAffixCallbackToModule",
    value: function shouldAffixCallbackToModule(modname) {
      if (modname == 'Arcade') {
        return 1;
      }
      for (var i = 0; i < this.affix_callbacks_to.length; i++) {
        if (this.affix_callbacks_to[i] == modname) {
          return 1;
        }
      }
      return 0;
    }
  }, {
    key: "isSlug",
    value: function isSlug(slug) {
      if (slug == this.returnSlug()) {
        return true;
      }
      return false;
    }
  }, {
    key: "webServer",
    value: function webServer(app, expressapp, express) {
      var alternative_slug = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var uri = alternative_slug || '/' + encodeURI(this.returnSlug());
      var webdir = "".concat(__dirname, "/../../mods/").concat(this.dirname, "/web");
      var arcade_self = this;
      expressapp.use(uri, express["static"](webdir));
      expressapp.get(uri, /*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee32(req, res) {
          var _app$options, _app$options2;
          var endpoint, protocol, host, port, reqBaseURL, game_data, updatedSocial, query_params, game, gm, game_id, html;
          return _regenerator().w(function (_context33) {
            while (1) switch (_context33.n) {
              case 0:
                //let reqBaseURL = req.protocol + '://' + req.headers.host + '/';
                endpoint = (app === null || app === void 0 || (_app$options = app.options) === null || _app$options === void 0 || (_app$options = _app$options.server) === null || _app$options === void 0 ? void 0 : _app$options.endpoint) || (app === null || app === void 0 || (_app$options2 = app.options) === null || _app$options2 === void 0 ? void 0 : _app$options2.server) || {};
                protocol = (endpoint.protocol || req.protocol || 'https').replace(/:$/, '');
                host = endpoint.host || req.hostname || req.headers.host;
                port = endpoint.port ? ":".concat(endpoint.port) : '';
                reqBaseURL = "".concat(protocol, "://").concat(host).concat(port, "/");
                game_data = null;
                updatedSocial = Object.assign({}, arcade_self.social);
                updatedSocial.url = reqBaseURL + encodeURI(arcade_self.returnSlug());
                if (Object.keys(req.query).length > 0) {
                  query_params = req.query;
                  game = (query_params === null || query_params === void 0 ? void 0 : query_params.game) || (query_params === null || query_params === void 0 ? void 0 : query_params.view_game);
                  if (typeof game === 'string') {
                    gm = app.modules.returnModuleBySlug(game) || app.modules.returnModule(game);
                    if (gm) {
                      updatedSocial.title = "Play <em>".concat(gm.returnName(), "</em> on the Saito Arcade");
                      updatedSocial.image = "".concat(reqBaseURL + gm.returnSlug(), "/img/arcade/arcade-banner-background.png"); /*arcade.jpg*/
                      updatedSocial.description = gm.description;
                      delete updatedSocial.url;
                    }
                  }
                  game_id = query_params === null || query_params === void 0 ? void 0 : query_params.game_id;
                  if (game_id != null) {
                    try {
                      game_id = decodeURIComponent(game_id);
                    } catch (_) {}
                  }
                  game_data = game_id && arcade_self.games[game_id] ? arcade_self.games[game_id].tx : null;

                  // console.log('WEBSERVER ARCADE GAME DATA --- ', game_data);
                }
                html = arcadeHome(app, arcade_self, app.build_number, updatedSocial, game_data);
                if (res.finished) {
                  _context33.n = 1;
                  break;
                }
                res.setHeader('Content-type', 'text/html');
                res.charset = 'UTF-8';
                return _context33.a(2, res.send(html));
              case 1:
                return _context33.a(2);
            }
          }, _callee32);
        }));
        return function (_x40, _x41) {
          return _ref5.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "_showReadyPopup",
    value: function _showReadyPopup(game_details) {
      if (!this.app.BROWSER) return;
      if (!this.ready_popup_overlay) {
        this.ready_popup_overlay = new SaitoOverlay(this.app, this, true, true, false);
        this.ready_popup_overlay.nonBlocking = true;
      }
      var slug = (game_details === null || game_details === void 0 ? void 0 : game_details.slug) || 'arcade';
      var name = (game_details === null || game_details === void 0 ? void 0 : game_details.name) || 'Game';
      var html = "\n  <div class=\"arcade-ready-popup\">\n    <div class=\"arcade-ready-popup-title\">Your game is ready!</div>\n    <div class=\"arcade-ready-popup-name\">".concat(name, "</div>\n    <div class=\"arcade-ready-popup-actions\">\n      <button class=\"saito-button-primary arcade-ready-popup-start\" data-slug=\"").concat(slug, "\">Start Game</button>\n      <button class=\"saito-button-secondary arcade-ready-popup-dismiss\">Dismiss</button>\n    </div>\n  </div>");
      this.ready_popup_overlay.show(html);
      var overlay = this.ready_popup_overlay;
      setTimeout(function () {
        var el = document.getElementById("saito-overlay".concat(overlay.ordinal));
        if (!el) return;
        var startBtn = el.querySelector('.arcade-ready-popup-start');
        var dismissBtn = el.querySelector('.arcade-ready-popup-dismiss');
        if (startBtn) {
          startBtn.onclick = function () {
            overlay.close();
            navigateWindow("/".concat(slug), 200);
          };
        }
        if (dismissBtn) {
          dismissBtn.onclick = function () {
            return overlay.close();
          };
        }
      }, 50);
    }
  }, {
    key: "showShareLink",
    value: function showShareLink(game_sig) {
      var show = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var data = {};
      var accepted_game_tx = null;
      var accepted_game_msg = null;

      //Add more information about the game
      var game = this.returnGame(game_sig);
      if (game) {
        accepted_game_tx = game.tx;
      }
      if (accepted_game_tx) {
        var _game_mod$returnSlug, _game_mod$returnSlug2, _accepted_game_msg;
        accepted_game_msg = accepted_game_tx.msg;
        var game_mod = this.app.modules.returnModule(accepted_game_msg.game) || this.app.modules.returnModuleBySlug(accepted_game_msg.game);
        data.game = (_game_mod$returnSlug = game_mod === null || game_mod === void 0 || (_game_mod$returnSlug2 = game_mod.returnSlug) === null || _game_mod$returnSlug2 === void 0 ? void 0 : _game_mod$returnSlug2.call(game_mod)) !== null && _game_mod$returnSlug !== void 0 ? _game_mod$returnSlug : accepted_game_msg.game;
        data.game_id = game_sig;
        data.path = '/arcade/';
        data.invite = 1;
        if ((_accepted_game_msg = accepted_game_msg) !== null && _accepted_game_msg !== void 0 && (_accepted_game_msg = _accepted_game_msg.options) !== null && _accepted_game_msg !== void 0 && _accepted_game_msg.crypto) {
          data.crypto = accepted_game_msg.options.crypto;
        }

        // This is not a meaningful safety catch... the sharelink button is only available for available games...
        if (accepted_game_msg.players_needed > 1) {
          var game_invitation_link = new GameInvitationLink(this.app, this, data);
          game_invitation_link.render(show);
        } else {
          console.error('no players needed');
        }
      } else {
        console.error('Game not available');
      }
    }
  }, {
    key: "makeGameInvite",
    value: function () {
      var _makeGameInvite = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee33(options) {
        var gameType,
          invite_obj,
          game,
          game_mod,
          players_needed,
          gamedata,
          open_invites,
          c,
          _iterator1,
          _step1,
          game_id,
          newtx,
          _args34 = arguments;
        return _regenerator().w(function (_context34) {
          while (1) switch (_context34.n) {
            case 0:
              gameType = _args34.length > 1 && _args34[1] !== undefined ? _args34[1] : 'open';
              invite_obj = _args34.length > 2 && _args34[2] !== undefined ? _args34[2] : {};
              game = options.game;
              game_mod = this.app.modules.returnModule(game);
              players_needed = options['game-wizard-players-select']; //
              // add league_id to options if this is a league game
              //
              if (invite_obj.league) {
                //The important piece of information
                options.league_id = invite_obj.league.id;
                //For convenience sake when making the join overlay
                options.league_name = invite_obj.league.name;
              }
              if (invite_obj.publicKey) {
                options.desired_opponent_publickey = invite_obj.publicKey;
                gameType = 'direct';
              }
              if (invite_obj.gameobj) {
                options.gameobj = invite_obj.gameobj;
                gameType = 'import';
              }
              if (players_needed) {
                _context34.n = 1;
                break;
              }
              console.error('ARCADE: [makeGameInvite] error, missing players_needed', options);
              return _context34.a(2);
            case 1:
              gamedata = {
                ts: new Date().getTime(),
                name: game,
                slug: game_mod.returnSlug(),
                options: options,
                players_needed: players_needed,
                invitation_type: gameType
              }; // Poker Validation
              if (!options['open-table']) {
                _context34.n = 3;
                break;
              }
              if (!(options.stake && _typeof(options.stake) === 'object')) {
                _context34.n = 3;
                break;
              }
              _context34.n = 2;
              return salert('Uneven staking is not allowed in cash games');
            case 2:
              options.stake = options.stake[this.publicKey].toString();
            case 3:
              if (!(players_needed == 1)) {
                _context34.n = 4;
                break;
              }
              this.launchSinglePlayerGame(gamedata);
              return _context34.a(2);
            case 4:
              open_invites = this.returnOpenInvites();
              if (!(open_invites.length > 0)) {
                _context34.n = 8;
                break;
              }
              _context34.n = 5;
              return sconfirm('You already have an open invite. Are you sure you want to create a new one?');
            case 5:
              c = _context34.v;
              if (c) {
                _context34.n = 6;
                break;
              }
              return _context34.a(2);
            case 6:
              _context34.n = 7;
              return sconfirm('Would you like to close the other invites?');
            case 7:
              c = _context34.v;
              if (c) {
                _iterator1 = _createForOfIteratorHelper(open_invites);
                try {
                  for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
                    game_id = _step1.value;
                    this.sendCancelTransaction(game_id);
                  }
                } catch (err) {
                  _iterator1.e(err);
                } finally {
                  _iterator1.f();
                }
              }
            case 8:
              if (gameType == 'direct') {
                if (gamedata.players_needed > 2) {
                  gamedata.invitation_type = 'open';
                } else {
                  gamedata.invitation_type = 'private';
                }
              }
              _context34.n = 9;
              return this.createOpenTransaction(gamedata);
            case 9:
              newtx = _context34.v;
              if (!(gameType == 'import')) {
                _context34.n = 10;
                break;
              }
              this.app.connection.emit('arcade-launch-game-import', newtx);
              return _context34.a(2);
            case 10:
              _context34.n = 11;
              return this.app.network.propagateTransaction(newtx);
            case 11:
              this.app.connection.emit('relay-send-message', {
                recipient: 'PEERS',
                request: 'arcade spv update',
                data: newtx.toJson()
              });
              if (this.app.browser.isMobileBrowser(navigator.userAgent) && !this.browser_active) {
                siteMessage('creating game invite...', 1500);
              }
              this.game_timeout = setTimeout(function () {
                salert("Your browser may have broadcast that invite, but network seems unstable. Please refresh to confirm!");
              }, 10000);
            case 12:
              return _context34.a(2);
          }
        }, _callee33, this);
      }));
      function makeGameInvite(_x42) {
        return _makeGameInvite.apply(this, arguments);
      }
      return makeGameInvite;
    }()
  }, {
    key: "observeGame",
    value: function () {
      var _observeGame = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee34(game_id) {
        var _game_id$substring, _game_mod, _game_mod$returnSlug3, _game_mod2;
        var watch_live,
          game_module_slug,
          game,
          game_tx,
          game_mod,
          game_msg,
          slug,
          _args35 = arguments;
        return _regenerator().w(function (_context35) {
          while (1) switch (_context35.n) {
            case 0:
              watch_live = _args35.length > 1 && _args35[1] !== undefined ? _args35[1] : false;
              game_module_slug = _args35.length > 2 && _args35[2] !== undefined ? _args35[2] : null;
              console.log('[OBS_TRACE] Arcade.observeGame()', {
                game_id: game_id === null || game_id === void 0 || (_game_id$substring = game_id.substring) === null || _game_id$substring === void 0 ? void 0 : _game_id$substring.call(game_id, 0, 12),
                watch_live: watch_live,
                game_module_slug: game_module_slug
              });
              game = this.returnGame(game_id);
              game_tx = game === null || game === void 0 ? void 0 : game.tx;
              game_mod = null;
              if (!game) {
                _context35.n = 4;
                break;
              }
              game_msg = game.tx.returnMessage();
              game_mod = this.app.modules.returnModule(game_msg.game);
              game_msg.game_id = game_id;
              if (!this.app.options.games) {
                this.app.options.games = [];
              }

              // So GameObserver can trigger FOLLOW after archive sync when watch_live was true
              game_mod.observer_watch_live = watch_live;
              if (game_mod.doesGameExistLocally(game_id)) {
                _context35.n = 2;
                break;
              }
              console.info('ARCADE Observer -- Initialize game');
              _context35.n = 1;
              return game_mod.initializeObserverMode(game_tx, false);
            case 1:
              _context35.n = 3;
              break;
            case 2:
              console.info('ARCADE Observer -- Game already exists, load it');
              game_mod.loadGame(game_id);
              game_mod.game.player = 0;
            case 3:
              _context35.n = 5;
              break;
            case 4:
              if (game_module_slug) {
                // No invite in arcade.games but we have the module slug (e.g. from observer link with archive data).
                // Navigate to the game module; it will load game from hash and archive.
                game_mod = this.app.modules.returnModuleBySlug(game_module_slug);
                if (game_mod) {
                  game_mod.observer_watch_live = watch_live;
                }
              }
            case 5:
              if (game_mod) {
                _context35.n = 6;
                break;
              }
              console.error('ARCADE: [observeGame] -- Game not found and no module slug');
              return _context35.a(2);
            case 6:
              slug = ((_game_mod = game_mod) === null || _game_mod === void 0 || (_game_mod$returnSlug3 = _game_mod.returnSlug) === null || _game_mod$returnSlug3 === void 0 ? void 0 : _game_mod$returnSlug3.call(_game_mod)) || ((_game_mod2 = game_mod) === null || _game_mod2 === void 0 ? void 0 : _game_mod2.slug) || game_module_slug || 'arcade';
              this.app.browser.navigateWindow("/".concat(slug, "?observer=1#gid=").concat(encodeURIComponent(game_id)));
            case 7:
              return _context35.a(2);
          }
        }, _callee34, this);
      }));
      function observeGame(_x43) {
        return _observeGame.apply(this, arguments);
      }
      return observeGame;
    }()
  }]);
}(ModTemplate);
module.exports = Arcade;